import { useState, useEffect } from "react";
import { UpdateTeamDTO } from "../../../types/team.types";
import { TeamForm } from "../../../components/team-form";
import { useNavigate, useParams } from "react-router-dom";
import { TeamsAPI } from "../../../APIs/teams.api";
import { useToast } from "../../../components/toast";
import { useCompetitions } from "../../../context/CompetitionsContext";
import { Loading } from "../../../components/loading";

export function TeamEdit() {
  const { id } = useParams<{ id: string }>();
  const [formData, setFormData] = useState<UpdateTeamDTO>({
    name: "",
    institution_id: 1,
  });
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { addToast } = useToast();
  const { currentCompetitionId } = useCompetitions();

  useEffect(() => {
    const loadTeamData = async () => {
      if (!id || !currentCompetitionId) return;

      try {
        const response = await TeamsAPI.getOneTeamOfCompetition(
          parseInt(id),
          currentCompetitionId
        );

        if (response.statusCode === 200) {
          setFormData({
            name: response.data.team.name,
            institution_id: response.data.institution.id,
          });
        } else {
          addToast({
            message: "Error al cargar los datos del equipo",
            type: "error",
            location: "bottom-center",
          });
          navigate(-1);
        }
      } catch (error) {
        addToast({
          message: "Error al cargar los datos del equipo",
          type: "error",
          location: "bottom-center",
        });
        navigate(-1);
      } finally {
        setIsLoading(false);
      }
    };

    loadTeamData();
  }, [id, addToast, navigate, currentCompetitionId]);

  function handleChange(e: React.ChangeEvent<HTMLElement>) {
    const { name, value } = e.target as HTMLInputElement;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!id) return;

    setIsSubmitting(true);
    try {
      const response = await TeamsAPI.adminUpdateTeam(parseInt(id), formData);
      if (response.statusCode === 200) {
        addToast({
          message: "¡Equipo actualizado!",
          type: "success",
          location: "bottom-center",
        });
        navigate(`/dashboard/teams/view/${id}`);
      } else {
        addToast({
          message: response.message,
          type: "error",
          location: "bottom-center",
        });
      }
    } catch (error) {
      addToast({
        message: "Error al actualizar el equipo, intente nuevamente",
        type: "error",
        location: "bottom-center",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen mt-10">
        <Loading />
      </div>
    );
  }

  return (
    <div className="min-h-screen mt-10">
      <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-md">
        <TeamForm
          team={formData}
          title="Editar Equipo"
          buttonText="Actualizar"
          isSubmitting={isSubmitting}
          onCancel={handleCancel}
          onSubmit={handleSubmit}
          handleChange={handleChange}
        />
      </div>
    </div>
  );
}
